import { type AxiosResponse } from 'axios'
import type { AxiosOptions } from 'shared/api'
import { baseApi } from 'entities/Auth'

import {
  type IParamsCustomField,
  type IParamsCustomFields,
  type IResponseCustomField,
  type IResponseCustomFields,
  type IResponseCustomFieldTypes,
  type IResponseDeleteCustomField,
} from './types'

class Api {
  getCustomFields<T extends IParamsCustomFields>(
    params: T,
    options?: AxiosOptions
  ): Promise<AxiosResponse<IResponseCustomFields<T>>> {
    return baseApi.get('custom-fields/fields', { params, ...options })
  }

  getCustomFieldTypes(): Promise<AxiosResponse<IResponseCustomFieldTypes>> {
    return baseApi.get('custom-fields/types')
  }

  createCustomField(params: IParamsCustomField): Promise<AxiosResponse<IResponseCustomField>> {
    return baseApi.post('custom-fields/field', params)
  }

  updateCustomField(
    id: number,
    params: IParamsCustomField
  ): Promise<AxiosResponse<IResponseCustomField>> {
    return baseApi.put(`custom-fields/field/${id}`, params)
  }

  deleteCustomField(id: number): Promise<AxiosResponse<IResponseDeleteCustomField>> {
    return baseApi.delete(`custom-fields/field/${id}`)
  }
}

export const CustomFieldApi = new Api()
